import React from "react";
import { useFormContext } from "react-hook-form";
import { Form } from "@sscs/ui";
import { ClaimSource } from "Types";
import { OIDCProviderConfigurationFormFields } from "../../types";
import FormPanel from "../FormPanel/FormPanel";

type ProviderConfigurationProps = {
  claimSource: ClaimSource;
};

const ProviderConfiguration = ({
  claimSource,
}: ProviderConfigurationProps): React.JSX.Element => {
  const {
    formState: { errors },
  } = useFormContext<OIDCProviderConfigurationFormFields>();

  return (
    <FormPanel
      title="Provider configuration"
      byline="These values will be defined in the admin dashboard of your SSO identity provider"
    >
      <Form.TextField
        label="Authorization endpoint"
        isRequired
        name="authorization_endpoint"
        id="authorization_endpoint"
        errors={errors}
        helperText="URL of your OpenID Connect provider authorization endpoint"
      />
      <Form.TextField
        label="Token endpoint"
        isRequired
        name="token_endpoint"
        id="token_endpoint"
        errors={errors}
        helperText="URL of your OpenID Connect provider token endpoint"
      />
      {claimSource === "user_info_endpoint" ? (
        <Form.TextField
          label="UserInfo endpoint"
          isRequired
          name="user_info_endpoint"
          id="user_info_endpoint"
          errors={errors}
          helperText="URL of your OpenID Connect provider userinfo endpoint"
        />
      ) : (
        <></>
      )}
      <Form.TextField
        label="Scopes"
        isRequired
        name="scopes"
        id="scopes"
        errors={errors}
        helperText="Space separated list of scopes to request during login"
      />
    </FormPanel>
  );
};

export default ProviderConfiguration;
